import React from 'react'

import { useTranslations } from '@dfb/gatsby-dfb-theme/src/hooks/useTranslations'

import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import DfbSelect from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_select'
import DfbInput from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_input'
import DfbParagraph from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_paragraph'
import DfbInputTextarea from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_input_textarea'
import MDefaultform from '../m_defaultForm'
import { extractFields } from '../../../../../../utils/form/extractFields'
import DfbInputUpload from '../../../ui-kit/dfb_input_upload'
import { emailRegex } from '../../../../../../utils/form/emailRegex'

const MJuliusHirschPreis = ({ data }) => {
  const t = useTranslations()
  const formType = data.form_definition[0].identifier
  const fields = extractFields(data.form_definition[0].form_field)

  const selectCategory = {
    label: 'placeholder',
    values: [
      {
        id: 0,
        name: 'Vorschlag',
      },
      {
        id: 1,
        name: 'Bewerbung',
      },
    ],
  }

  return (
    <MDefaultform
      buttonLabel="Anfrage absenden"
      postUrl={process.env.FORM_API_URL}
      disableCaptcha={data.form_definition[0].captcha === 0}
      formType={formType}
    >
      {({ register, errors }) => (
        <>
          {data.form_recipient && <input type="hidden" name="recipient" value={data.form_recipient[0].identifier} />}
          {data.headline && <DfbHeadline headline={data.headline} headline_level="h3" add_class="m-Formblock-headline" />}

          {selectCategory && (
            <div className="m-Formblock-row-third">
              {selectCategory.values.length >= 2 && (
                <div className="m-Formblock-row-third-cell">
                  <DfbSelect
                    {...register('category', {
                      required: t('form.errorMessage.select'),
                    })}
                    label={t('form.juliusHirschPreis.selectCategory.label')}
                    options={selectCategory.values.length >= 1 ? selectCategory.values : selectCategory.values[0]}
                    placeholder={t('form.placeholder.select')}
                    errorMessage={errors?.category?.message}
                    error={errors['category']}
                  />
                </div>
              )}
              <div className="m-Formblock-row-third-cell"></div>
              <div className="m-Formblock-row-third-cell"></div>
            </div>
          )}

          <div className="m-Formblock-spacer"></div>

          {(fields.firstname || fields.lastname || fields.email) && (
            <div className="m-Formblock-row-third">
              {[fields.firstname, fields.lastname, fields.email].filter(Boolean).map((formItem, index) => (
                <div className="m-Formblock-row-third-cell" key={index}>
                  <DfbInput
                    {...register(formItem.identifier, {
                      required: formItem.required ? t('form.errorMessage.input') : false,
                      pattern:
                        formItem.identifier === fields.email?.identifier
                          ? {
                              value: emailRegex,
                              message: t('form.errorMessage.emailPattern'),
                            }
                          : undefined,
                    })}
                    error={errors[formItem.identifier]}
                    errorMessage={errors?.[formItem.identifier]?.message}
                    label={`${formItem.label}${formItem.required === 1 ? '*' : ''}`}
                    focused
                  />
                </div>
              ))}
            </div>
          )}

          {fields.phone && (
            <div className="m-Formblock-input">
              <DfbInput
                {...register(fields.phone.identifier, {
                  required: fields.phone.required === 1 ? t('form.errorMessage.input') : false,
                })}
                error={errors[fields.phone.identifier]}
                errorMessage={errors?.[fields.phone.identifier]?.message}
                label={`${fields.phone.label}${fields.phone.required === 1 ? '*' : ''}`}
                focused
              />
            </div>
          )}

          <div className="m-Formblock-spacer"></div>

          {fields.houseNumber && (
            <div className="m-Formblock-input">
              <DfbInput
                {...register(fields.houseNumber.identifier, {
                  required: fields.houseNumber.required ? t('form.errorMessage.input') : false,
                })}
                error={errors[fields.houseNumber.identifier]}
                errorMessage={errors?.[fields.houseNumber.identifier]?.message}
                label={`${fields.houseNumber.label}${fields.houseNumber.required === 1 ? '*' : ''}`}
                focused
              />
            </div>
          )}

          {(fields.postcode || fields.location) && (
            <div className="m-Formblock-input-half">
              {[fields.postcode, fields.location].filter(Boolean).map((formItem, index) => (
                <div className="m-Formblock-input" key={index}>
                  <DfbInput
                    {...register(formItem.identifier, {
                      required: formItem.required ? t('form.errorMessage.input') : false,
                      ...(formItem.identifier === 'postcode' && {
                        pattern: {
                          value: /^\d+$/,
                          message: t('form.errorMessage.postcodePattern'),
                        },
                      }),
                    })}
                    error={errors[formItem.identifier]}
                    errorMessage={errors?.[formItem.identifier]?.message}
                    label={`${formItem.label}${formItem.required === 1 ? '*' : ''}`}
                    focused
                  />
                </div>
              ))}
            </div>
          )}

          <div className="m-Formblock-spacer"></div>

          {fields.team && (
            <div className="m-Formblock-input">
              <DfbInput
                {...register(fields.team.identifier, {
                  required: fields.team.required === 1 ? t('form.errorMessageInput') : false,
                })}
                error={errors[fields.team.identifier]}
                errorMessage={errors?.[fields.team.identifier]?.message}
                label={`${fields.team.label}${fields.team.required === 1 ? '*' : ''}`}
                focused
              />
            </div>
          )}

          {fields.website && (
            <div className="m-Formblock-input">
              <DfbInput
                {...register(fields.website.identifier, {
                  required: fields.website.required === 1 ? t('form.errorMessage.input') : false,
                })}
                error={errors[fields.website.identifier]}
                errorMessage={errors?.[fields.website.identifier]?.message}
                label={`${fields.website.label}${fields.website.required === 1 ? '*' : ''}`}
                focused
              />
            </div>
          )}

          {fields.projectdescription && (
            <div className="m-Formblock-input">
              <DfbInputTextarea
                {...register(fields.projectdescription.identifier, {
                  required: fields.projectdescription.required === 1 ? t('form.errorMessage.input') : false,
                })}
                label={`${fields.projectdescription.label}${fields.projectdescription.required === 1 ? '*' : ''}`}
                error={errors[fields.projectdescription.identifier]}
                errorMessage={errors?.[fields.projectdescription.identifier]?.message}
              />
            </div>
          )}

          <div className="m-Formblock-input">
            <DfbInputUpload
              {...register('upload')}
              uploadLabel="Upload"
              error={errors['upload']}
              errorMessage={errors?.['upload']?.message}
            />
          </div>

          <div className="m-Formblock-spacer"></div>

          <div className="m-Formblock-checkbox">
            <DfbParagraph text={t('form.privacyText')} />
          </div>
        </>
      )}
    </MDefaultform>
  )
}

export default MJuliusHirschPreis
